import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS } from 'chart.js/auto';
import { useState, useEffect } from "react";
import axiosConfig from '../axiosConfig';



const BarGraphData = (props) => {


    const [Data, setData] = useState({
        labels: [],
        datasets: []
    });
    useEffect(() => {

        setData(() => ({
            labels: props.channel, datasets: [{
                data: props.value,
                backgroundColor: props.color,
                //borderColor: "black",
                borderWidth: 1,
                categoryPercentage: 0.7,
                barPercentage: 0.7
            }]
        }));

    }, [props]);

    var start_string = new Date(props.start).toLocaleString(undefined, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
    var finish_string = new Date(props.finish).toLocaleString(undefined, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
    var finish= new Date(props.finish);
    
    return (
        <div>
            <div className="card">

                <div className="card-content collapse show" >
                    <div className="card-header">
                        <h4 className="card-title  text-center">{props.title}</h4>
                        {(() => {
                            if (start_string !== "Invalid Date") {
                                return <h4 className="h6 text-center">{(finish.getDate()<10)?"0"+finish.getDate().toString():finish.getDate()}.{(finish.getMonth()+1<10)?"0"+(finish.getMonth()+1).toString():finish.getMonth()+1}.{finish.getFullYear()}; 12:00 AM - 11:59 PM</h4>


                            } else {
                                return null;

                            }
                        })()}
                    </div>
                    {(() => {

                        if (props.loading) {
                            return <Bar
                                data={Data}
                                options={{
                                    title: {
                                        display: true,
                                        text: props.text,
                                        fontSize: 20
                                    },
                                    legend: {
                                        display: true,
                                        position: 'right'
                                    }
                                    , plugins: {
                                        legend: {
                                            display: false  //remove if want to show label
                                        }
                                    }




                                }}
                            />


                        } else {
                            return <img src="https://upload.wikimedia.org/wikipedia/commons/c/c7/Loading_2.gif?20170503175831" className="rounded mx-auto d-block" alt="..." />

                        }

                    })()}
                </div>
            </div>

        </div>

    );
}
export default BarGraphData;
